import { cva } from "class-variance-authority";

const stylesButton = cva(
  "flex items-center bg-gray w-[158px] h-[40px] mb-[12px] px-[12px] rounded-[8px]",
  {
    variants: {
      mode: {
        light: "bg-light-fill-secondary hover:bg-light-hover-fill-secondary",
        dark: "bg-dark-hover-fill-secondary hover:bg-dark-fill-tertiary"
      }
    }
  }
);

export { stylesButton };
